import { useMemo } from 'react';
import { useGetCurrentUserQuery } from 'services/kewloxApi';

export const useUserGroups = () => {
  const { data: user, isLoading, error, refetch } = useGetCurrentUserQuery();

  const userGroups = useMemo(() => {
    return user?.groups || [];
  }, [user?.groups]);

  const hasGroup = (groupName: string) => {
    return userGroups.includes(groupName);
  };

  const hasAnyGroup = (groupNames: string[]) => {
    return groupNames.some(group => userGroups.includes(group));
  };

  const hasAllGroups = (groupNames: string[]) => {
    return groupNames.every(group => userGroups.includes(group));
  };

  return {
    user,
    userGroups,
    hasGroup,
    hasAnyGroup,
    hasAllGroups,
    isLoading,
    error,
    refetch,
  };
};
